export enum GenerationTechnology {
  SOLAR = 'solar',
  WIND_ONSHORE = 'wind_onshore',
  WIND_OFFSHORE = 'wind_offshore',
  COMBINED_HEAT_POWER = 'combined_heat_power',
  WATER = 'water',
}
